export default "__VITE_ASSET__ClZWCp$O__"